// QR Kod Sayfası Tasarla penceresi (görev ve anket QR'ı) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'tasks.qrPrint';

export const qrPrintGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'QR kod sayfası nasıl tasarlanır?'),
  intro: t(`${G}.intro`, 'Görev veya anket için QR kodlu, A5 boyutunda bir sayfa hazırlayıp yazdırırsınız ya da dosya olarak indirirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    list: t(`${G}.regions.list`, 'A5 tasarım alanı'),
    form: t(`${G}.regions.form`, 'Araçlar'),
    footer: t(`${G}.regions.footer`, 'İndir, kaydet, yazdır'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu pencere ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Pencere hangi görevden veya anketten açıldıysa QR kod ona ait bağlantıyı taşır. Sayfada QR kod yoksa pencere açılınca kendiliğinden eklenir. Bu sayfayı yazdırıp görevin yapılacağı ya da anketin doldurulacağı yere asabilirsiniz.'),
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Öğeleri yerleştirin'),
      text: t(`${G}.s2.text`, 'Soldaki A5 sayfada QR kodu, logoları ve metinleri fareyle sürükleyerek istediğiniz yere taşıyın. Bir öğeye tıklayınca seçilir ve mavi çerçeveyle görünür; sağdaki ayarlar seçili öğeye uygulanır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Metin kutusunun genişliğini, seçiliyken sağ alt köşesinden sürükleyerek değiştirirsiniz.'),
        t(`${G}.s2.tip2`, 'Seçili öğeyi kaldırmak için sağdaki "Seçili Öğeyi Sil" düğmesine basın.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Sayfa, QR kod ve logo'),
      text: t(`${G}.s3.text`, '"Sayfa Yönlendirmesi" ile sayfayı Dikey ya da Yatay yapın; "Arkaplan Rengi" ile sayfa rengini seçin. "QR Ekle" / "QR Kaldır" QR kodu sayfaya ekler veya kaldırır. "Logo Ekle" ile bilgisayarınızdan PNG veya JPG resim seçersiniz.'),
      tips: [
        t(`${G}.s3.tip1`, '"QR Kod Boyutu" ve "Logo Boyutu" kaydırıcıları seçili öğenin boyutunu değiştirir; önce sayfadaki öğeye tıklayıp seçin.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Metin ekleyin ve biçimlendirin'),
      text: t(`${G}.s4.text`, '"Metin Ekle" sayfaya yeni bir metin koyar. Metin seçiliyken "Metin Düzenleme" bölümünde yazıyı, yazı tipini, yazı boyutunu, hizalamayı, kalın/italik stilini ve yazı rengini değiştirirsiniz.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Tasarımı kaydedin ve tekrar kullanın'),
      text: t(`${G}.s5.text`, 'Pencereyi kapattığınızda bu görevin/anketin tasarımı kendiliğinden saklanır ve bir dahaki açılışta geri gelir. "Tasarımı Kaydet" ile tasarıma ad verip saklarsınız; "Tasarım Seç" ile kayıtlı bir tasarımı başka bir göreve de uygularsınız. QR kod her zaman açık olan görevin/anketin bağlantısını gösterir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Tasarımlar sunucuya değil, bu bilgisayardaki tarayıcıya kaydedilir; başka bilgisayarda veya tarayıcı verisi silinince görünmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Yazdırın veya indirin'),
      text: t(`${G}.s6.text`, '"Yazdır" sayfayı A5 olarak yazdırma penceresinde açar; tarayıcı açılır pencereyi engellerse izin verin. "Bilgisayara Kaydet" tüm sayfayı JPG resim olarak indirir.'),
      tips: [
        t(`${G}.s6.tip1`, '"QR PDF İndir" ve "QR İndir" (PNG) yalnız QR kodu indirir; sayfada QR yokken kapalıdır.'),
        t(`${G}.s6.tip2`, '"Vektörel İndir": matbaa ve tabela için SVG, EPS, DXF veya TIF biçimlerinde yalnız QR kodu indirir.'),
      ],
    },
  ],
});
